import React from "react";
import { Main } from "../../components/utilities";
import ClientSummaryDetails from "./components/ClientSummaryDetails";
import { ClientSummaryProvider } from "./hooks/ClientSummaryContext";
import withProviders from "../../hooks/withProviders";
import ProjectSummaryDetails from "./components/ProjectSummaryDetails";
import { Row, Col } from "react-bootstrap";
import NotesSummaryDetails from "./components/NotesSummaryDetails";
import AccountSummaryDetails from "./components/AccountSummaryDetails";
import PortfolioValuationSummaryDetails from "./components/PortfolioValuationSummaryDetails";
import DashboardLoginsDetails from "./components/DashboardLoginsDetails";

const ClientSummary = () => (
    <Main className="p-3">
        <Row className="p-2">
            <AccountSummaryDetails />
            <PortfolioValuationSummaryDetails />
        </Row>
        <Row className="p-2">
            <NotesSummaryDetails />
        </Row>
        <Row className="p-2">
            <ProjectSummaryDetails />
            <DashboardLoginsDetails />
        </Row>
    </Main>
);

export default withProviders([ClientSummaryProvider])(ClientSummary);